import { tryCatchHelper } from '../../../../helpers';
import {
  ACTIVO_SUSCRIPCIONES,
  ALL_SUSCRIPCIONES,
  LOADING_ALL_SUSCRIPCIONES,
} from './SuscripcionesReducer';
import {
  deleteSuscripcionesService,
  allSuscripcionesService,
  oneSuscripcionesService,
  saveSuscripcionesService,
} from './SuscripcionesService';

export const allSuscripcionesAction = async (dispatch, params) => {
  try {
    dispatch({ type: LOADING_ALL_SUSCRIPCIONES, payload: true });
    const res = await allSuscripcionesService(params);
    if (res.status === 200) {
      dispatch({ type: ALL_SUSCRIPCIONES, payload: res.data });
      dispatch({ type: LOADING_ALL_SUSCRIPCIONES, payload: false });
      return res.data;
    }
    dispatch({ type: LOADING_ALL_SUSCRIPCIONES, payload: false });
    return null;
  } catch (e) {
    dispatch({ type: LOADING_ALL_SUSCRIPCIONES, payload: false });
    tryCatchHelper(e);
    return false;
  }
};

export const saveSuscripcionesAction = async (
  { dispatch, notify },
  id,
  data,
  params,
) => {
  try {
    const res = await saveSuscripcionesService(id, data);
    notify(res.data.message);
    await allSuscripcionesAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const setActivoSuscripcionesAction = async (dispatch, data) => {
  dispatch({ type: ACTIVO_SUSCRIPCIONES, payload: data });
};

export const oneSuscripcionesAction = async (dispatch, id) => {
  try {
    const res = await oneSuscripcionesService(id);
    await setActivoSuscripcionesAction(dispatch, res.data);
    return res.data;
  } catch (e) {
    tryCatchHelper(e);
    return false;
  }
};

export const deleteSuscripcionesAction = async (
  { dispatch, notify },
  id,
  params,
) => {
  try {
    const res = await deleteSuscripcionesService(id);
    notify(res.data.message);
    await setActivoSuscripcionesAction(dispatch, null);
    await allSuscripcionesAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};
